<section>
  <section style="height: auto;">
    <nav>
      <ol class="cd-breadcrumb custom-separator">
        <table>
          <tbody>
            <tr>
              <td class="nomeTela">
                Cadastro de Relatório
              </td>
            </tr>
          </tbody>
        </table>
      </ol>
    </nav>
  </section>
  <main>
    <section class="main-section">
      <form class="form-class" data-toggle="collapse">
        <div class="form-div p-3" [style.display]="EhEtapa1 ? 'none' : 'block'">
          <label for="indicador" class="form-label">Relatório <span matTooltip="Relatório que faz parte dessa etapa "><i
                class="fas fa-question-circle"> </i></span></label>
          <select [(ngModel)]="novoItem.codigo" #mySelectRelatorio name="select" class="form-select"
            (change)="onOptionChange(mySelectRelatorio.value)">
            <option value="">Escolha o Relatório</option>
            <option *ngFor="let objeto of listaIndEtapa1" value={{objeto.codigo}}>{{objeto.nome}}</option>
          </select>
        </div>
        <input type="text" class="form-control" id="id" name="id" [(ngModel)]="novoItem.id" required
          style="display: none;">
          <div class="form-div p-3">
            <label for="etapa" class="form-label">Etapa <span class="required">* </span> <span
                matTooltip="Qual etapa do indicador"><i class="fas fa-question-circle"> </i></span></label>
            <fieldset class="fieldInput">
              <input type="number" class="form-control form-input" [readonly]="TravaEtapa"
                [ngClass]="{'readonly': TravaEtapa, 'editable': !TravaEtapa}" (input)="handleInputChange($event)"
                id="etapa" name="etapa" [(ngModel)]="novoItem.etapa" required>
              <button type="submit" (click)="alterarTravaEtapa(!TravaEtapa)" class="form-submit"><i *ngIf="TravaEtapa"
                  class="fas fa-lock"></i><i *ngIf="!TravaEtapa" class="fas fa-lock-open"></i></button>
            </fieldset>
          </div>
          <div class="form-div p-3">
            <label for="nome" class="form-label">Nome</label>
            <input type="text" class="form-control" id="nome" name="nome" [(ngModel)]="novoItem.nome" required>
            <!-- <div id="nomePosto" class="form-text">Insira o nome do posto.</div> -->
          </div>
          <div class="form-div p-3">
            <label for="descricao" class="form-label">Descrição</label>
            <input type="text" class="form-control" id="descricao" name="descricao" [(ngModel)]="novoItem.descricao"
              required>
            <!-- <div id="nomePosto" class="form-text">Insira o nome do posto.</div> -->
          </div>
        @if(EhEtapa1)
        {
        <div class="form-div p-3">
          <label for="codigo" class="form-label">Codigo</label>
          <input type="number" class="form-control" id="codigo" name="codigo" [(ngModel)]="novoItem.codigo" required>
          <!-- <div id="nomePosto" class="form-text">Insira o nome do posto.</div> -->
        </div>
        
        <div class="form-div p-3">
          <label for="editorHtml" class="form-label">Editar Texto Ajuda <span
              matTooltip="Texto que será mostrado no ajuda desse indicador referente ao cálculo e as cores"><i
                class="fas fa-question-circle"> </i></span></label>
          <quill-editor [modules]="editorConfig" class="form-control" id="textoAjudaHTML" name="textoAjuda"
            [(ngModel)]="novoItem.textoAjudaHTML"></quill-editor>
        </div>
      }
        <div style="display: flex; justify-content: right; margin-top: 15px;">
          <button (click)="validateAndFormat(novoItem.consulta)" class="btn btn-secondary"
            matTooltip="Esse botão verifica se o formato da consulta é um json válido">Validar e Formatar
            JSON</button>
        </div>
        <div class="form-div p-3">
          <label for="consulta" class="form-label">Consulta <span
              matTooltip=" Parâmetros, variável, alterando, número, necessário"><i class="fas fa-question-circle">
              </i></span></label>
          <textarea type="text" class="form-control" id="consulta" name="consulta" [(ngModel)]="novoItem.consulta"
            required></textarea>
          <div id="consultaHelpBlock" class="form-text">
            Utilize esses parâmentros para indicar data: #sc:inicio_dia#; #sc:fim_dia#; #sc:data_atual#; ou
            filtrar por id: #sc:id#;<br />
            A variavel #sc:data_atual# pode ser implementada como #sc:data_atual-Xh#, #sc:data_atual+Xmin#,
            #sc:data_atual-Xs# altereando o X para um número necessário.
          </div>
        </div>
        <div class="form-div p-3">
          <label for="colecao" class="form-label">Coleção <span matTooltip="Nome do index do indicador"><i
                class="fas fa-question-circle"></i></span></label>
          <input type="text" class="form-control" id="colecao" name="colecao" [(ngModel)]="novoItem.colecao" required>
        </div>
        <div class="div-buttons div-button mb-3 p-3">
          <a [routerLink]="['/relatorio-listagem']"><button id="class-button"
              class="btn btn-secondary">Voltar</button></a>
          <div>
            <button id="class-button" style="margin-right: 10px;" (click)="Limpar()"
              class="btn btn-secondary">Limpar</button>
            <button id="class-button" (click)="submitForm()" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </form>
    </section>
  </main>
</section>